import { render, staticRenderFns } from "./PagoConDNI.vue?vue&type=template&id=70f7cc48&"
import script from "./PagoConDNI.vue?vue&type=script&lang=js&"
export * from "./PagoConDNI.vue?vue&type=script&lang=js&"
import style0 from "./PagoConDNI.vue?vue&type=style&index=0&id=70f7cc48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports